import { Drawer, Grid2 } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { StandardButton } from "../../../_components/button/primary.button";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { toastr } from "../../../_components/toastr/toastr";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { clientService } from "../../../_services/client.service";
import { IClientManage } from "../../../_common/models/client/clientManage.model";
import { getFormatedDate } from "../../../_helpers/dateTime.helper";
import { DataTypeEnum } from "../../../_common/enum/dataType.enum";
import { DataTypeAutoComplete } from "../../../_components/autocomplete/dataType.autocomplete";

export const ClientMedicalInfoManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {
    const { clientId } = useParams<{ clientId: string }>();

    const resetData = (): IClientManage => ({
        id: clientId ? Number(clientId) : 0,
        fName: '',
        lName: '',
        centreId: 0,
        nickname: '',
        phone: '',
        dob: '',
        height: null,
        weight: null,
        mobilePhone: '',
        medicalCardNo: '',
        medicalCardExpiry: '',
        allergies: '',
        eyeColourId: null,
        hairColourId: null,
        ethnicOriginId: null,
        careStatusId: null,
        genderId: 0,
        bodyTypeId: null,
        ppsn: '',
        dateOfAdmission: '',
        primaryKeyWorkerId: null,
        secondaryKeyWorkeryId: null,
        lhoAreaId: null,
        email: '',
        complexionId: null,
        caseManagerId: null,
        distinguishingFeatures: '',
        noOfExistingSENs: 0,
        initials: '',
        isActive: true
    });

    const [data, setData] = useState<IClientManage>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        if (clientId != null)
            fetchData();
        else
            setData(resetData);
    }, [clientId]);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    function fetchData() {
        if (!clientId) return;

        setIsLoading(true);
        return clientService
            .get(clientId)
            .then(
                (json: IClientManage) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);
        return clientService
            .submit(data)
            .then(
                () => {
                    resetData();
                    params.onSave();
                    toastr.success("Saved successfully");
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function cancel() {
        navigate(-1);
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Update Medical info"} onClose={params.onClose} />

            <ValidatorForm
                onSubmit={submit}
                noValidate>

                <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="medicalCardNo"
                            name="medicalCardNo"
                            label="Medical Card No."
                            fullWidth
                            value={data.medicalCardNo}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            name="medicalCardExpiry"
                            label="Medical Card Expiry"
                            fullWidth
                            type="date"
                            value={getFormatedDate(data.medicalCardExpiry)}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="allergies"
                            name="allergies"
                            label="Allergies"
                            fullWidth
                            value={data.allergies}
                            onChange={handleChange}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: !data.id ? 12 : data?.isActive === false ? 12 : 6 }}>
                                <StandardButton
                                    saving={saving}
                                    loading={isLoading}
                                    icon="save"
                                    type="submit">
                                    {(data?.isActive === false) ? "Save and Reactivate" : "Save"}
                                </StandardButton>
                            </Grid2>

                            {(!!clientId && data?.isActive === true) &&
                                <Grid2 size={{ xs: 6 }}>
                                    <StandardButton
                                        saving={saving}
                                        loading={isLoading}
                                        icon="block"
                                        variant="error"
                                        onClick={cancel}
                                    >
                                        Cancel
                                    </StandardButton>
                                </Grid2>
                            }
                        </Grid2>
                    </Grid2>
                </Grid2>

            </ValidatorForm>
        </Drawer>
    );
};